import { render, staticRenderFns } from "./product-banner.vue?vue&type=template&id=0834141e&scoped=true&"
import script from "./product-banner.vue?vue&type=script&lang=js&"
export * from "./product-banner.vue?vue&type=script&lang=js&"
import style0 from "./product-banner.vue?vue&type=style&index=0&id=0834141e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834141e",
  null
  
)

export default component.exports